import { render, staticRenderFns } from "./AppointmentShortInfo.vue?vue&type=template&id=244060e1"
import script from "./AppointmentShortInfo.vue?vue&type=script&lang=js"
export * from "./AppointmentShortInfo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports